<template>
    <div id="main-sidebar">
        <div class="brand">
            <logo-links></logo-links>
        </div>
        <app-search class="mb-4"></app-search>
        <recent-applications class="mb-4"></recent-applications>
        <sidebar-navigation></sidebar-navigation>
    </div>
</template>

<script>
import LogoLinks from "@/components/LogoLinks";
import RecentApplications from "@/components/RecentApplications";
import SidebarNavigation from "@/components/SidebarNavigation";
import AppSearch from "@/components/AppSearch";

export default {
    name: "main-sidebar",
    components: {
        LogoLinks,
        SidebarNavigation,
        RecentApplications,
        AppSearch
    }
}
</script>

<style lang="scss" scoped>
#main-sidebar {
    position: absolute;
    width: $sidebar-width;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: -$sidebar-width;
    background-color: $primary;
    @include fastestTransition;
    .brand {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: $header-height;
        padding: 0px $sidebar-padding;
    }
    &.active {
        margin-left: 0;
    }
    @media screen and (max-width: $breakpoint-sm) {
        width: $sidebar-width-xs;
        margin-left: -$sidebar-width-xs;
    }
}

.dark {
    #main-sidebar {
        background-color: $extra-darkest-gray;
    }
}
</style>